import { useEffect } from 'react';

const useGlobalListener = (eventType: string, callback: (...props: any[]) => void) => {
  useEffect(() => {
    if (!callback) return;
    document.addEventListener(eventType, callback);

    return () => document.removeEventListener(eventType, callback);
  }, [eventType, callback]);
};

export default useGlobalListener;
